// extracted by mini-css-extract-plugin
module.exports = {"container":"Page_container__Rr1r1","content":"Page_content__jBY5h"};